exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".zui-toast{top:50%;left:50%;width:1.302083rem;padding:.104167rem;position:fixed;color:#fff;font-size:.083333rem;text-align:center;border-radius:.052083rem;background:rgba(0,0,0,.7);animation:toastScaleIn .2s ease forwards}@keyframes toastScaleIn{0%{transform:scale(.8) translate(-50%,-50%)}to{transform:scale(1) translate(-50%,-50%)}}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/px2rem-webpack-loader?{"baseDpr":1,"remUnit":192,"remPrecision":6,"forcePxComment":"px","keepComment":"no","remLimit":1,"exclude":{}}!./src/components/less/toast.css
// module id = 939
// module chunks = 0